import { WasabiButton } from '@kk/ui';
import { useEffect, type PropsWithChildren, type ReactNode } from 'react';

import { placeholders } from '@/copy/placeholders';

/** A sheet over the rgba(0,0,0,.45) scrim (O01 proof / deny; O07 menu). Escape and the scrim close it. */
export function Sheet({
  title,
  onClose,
  children,
  testID,
}: PropsWithChildren<{ title: ReactNode; onClose: () => void; testID?: string }>) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div className="scrim" onClick={onClose} data-testid={testID}>
      <div className="sheet" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <div className="sheet-head">
          <div className="grow">{title}</div>
          <WasabiButton
            label={placeholders.sheet.close}
            variant="text"
            textSize="sm"
            fullWidth={false}
            onPress={onClose}
          />
        </div>
        {children}
      </div>
    </div>
  );
}
